import React, {useEffect, useState} from 'react'
import '../css/soluciones.css'
import '../css/promociones_carga.css'
import carga from '../assets/video/carga.mp4'

import { Outlet, Link } from "react-router-dom";
import '../css/navbar.css'

import heroCarga from '../assets/images/carga/imageBG.webp'
import FooterCarga from '../components/FooterCarga' 

import ruta from '../assets/images/ruta3.png'
import tarifa from '../assets/images/tarifa.png'

import integracion from '../assets/images/soluciones/integracion.webp'
import maritimo from '../assets/images/soluciones/maritimo.webp'
import terrestre from '../assets/images/soluciones/autotransporte.webp'
import multimodal from '../assets/images/soluciones/ferroviario.webp'

import promo1 from '../assets/images/promociones/promo1.png'
import promo2 from '../assets/images/promociones/promo2.png'
import '../css/callToAction_carga.css'

import reservacion from '../assets/images/cta/reservacion.svg'
import formulario from '../assets/images/formulario-de-contacto.svg'
import mapa from '../assets/images/pregutas.png'

import HeaderCarga from '../components/HeaderCarga';
import ItinerarioCarga from '../components/ItinerarioCarga';
import PromocionesHorizontal from '../components/PromocionesHorizontal';
import { useTranslation } from 'react-i18next';

export default function SolucionesLogisticas() {
    const { t } = useTranslation('solucionesLogisticas');
    const [nombre, setNombre] = useState('');
	const [empresa, setEmpresa] = useState('');
	const [telefono, setTelefono] = useState('');
	const [email, setEmail] = useState('');
	const [mensaje, setMensaje] = useState('');
	const [alert, setAlert] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
    };
  
    window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    const enviarCorreo = async () => {
        /*  try {
              //await axios.post('http://localhost:3001/enviar-correo', {
                  await axios.post('/api/enviar-correo', {
                  nombre,
                  empresa,
                  telefono,
                  servicio,
                  email,
                  mensaje,
              }, {
                  headers: {
                      'Content-Type': 'application/json',
                      // Agrega otros encabezados si son necesarios
                  },
              });
      
              // Limpiar campos después de enviar el correo
              setNombre('');
              setEmpresa('');
              setTelefono('');
              setServicio('');
              setEmail('');
              setMensaje('');
      
              setAlert(true);
          } catch (error) {
              console.error('Error al enviar el correo:', error);
              alert('Error al enviar el correo');
          }*/
              setAlert(true);
    };

  return (
    <>
    {/*<Navbar />*/}
    <HeaderCarga />
    <section id='soluciones'>
        <div className='header_soluciones'>
        
            {!isMobile ? (
            <video muted loop autoPlay={true} playsinline preload={false} width="750" height="500" >
                <source src={carga} type="video/mp4" /> 
            </video>
            ) : (
                <div className='heroImg_carga'>
                    <img src={heroCarga} alt='baja ferries hero' />
                    <div className='hero-text-carga'>
                        <h1> {t('soluciones_title')}</h1>    
                        <p> {t('soluciones_p')}</p>
                    </div>                                    
                </div>
            )}

            <div className='header_title_soluciones '>
                <div className='container'>
                    <div className='title_soluciones'>
                       {/* <h2>Soluciones logísticas</h2>
                        <p>Ofrecemos soluciones logísticas integrales y multimodales para el traslado de todo tipo de mercancías a cualquier destino. </p>      */}      
                        <ItinerarioCarga />
                    </div>                    
                </div>                               
            </div>
        </div>
        {/*<section className='d-none d-sm-none d-md-block'>
            <section className='promociones-carga'>
                <div className='container'>
                    <div className='promociones_home_carga '>
                        <h2>{t('promo_title_carga')}</h2>
                        <p>{t('promo_description_carga')}</p>
                        
                        <div className='promociones_home_cta_carga'>
                            <Link to="/promociones" class="learn-more-carga">
                                <span class="circle" aria-hidden="true">
                                <span class="icon arrow"></span>
                                </span>
                                <span class="button-text">{t('ver_mas')}
                                </span>
                            </Link>
                        </div>
                    </div>
                    <div className='promociones-carga-container'>
                        <Link to="/promo-abordo"> 
                            <img src={promo1} alt='sorteo baja ferries' />
                        </Link> 
                        <Link to="/promo-abordo"> 
                            <img src={promo2} alt='sorteo baja ferries' />
                        </Link> 
                    </div>

                </div>
            </section>
        </section>
        <section class="d-block d-sm-block d-md-none">
                <div className="container" id='promociones'>                                
                    <PromocionesHorizontal />                         
                </div>
        </section>*/}

        <section className='services_carga'>
            <div className='container'>
                <div className='services_carga_content'>
                    <div className='services_carga_title'>
                        <div className='services_carga_title_box'>
                            <h2>{t('texto16')} </h2>
                            <p>{t('texto17')}  {t('texto18')}</p>
                        </div>
                    </div>
                    
                    <Link to="/maritimo"> 
                        <div className='services_carga_box'>
                            <div className='services_carga_box_img'>
                                <img src={maritimo} alt='servicios terrestres baja ferries' />                        
                                <div className='services_carga_box_text'>
                                    <h3>{t('texto13')}</h3>
                                    <p>{t('texto19')}</p>
                                </div>
                            </div>                     
                        </div>
                    </Link>
                    
                    <Link to="/integracion-logistica"> 
                        <div className='services_carga_box'>
                            <div className='services_carga_box_img'>
                                <img src={integracion} alt='servicios terrestres baja ferries' />                        
                                <div className='services_carga_box_text'>
                                    <h3>{t('texto12')}</h3>
                                    <p>{t('texto22')}</p>
                                </div>
                            </div>                     
                        </div>
                    </Link>
                    
                </div>
            </div>
        </section>
{/*}
        <section className='services_carga'>
            <div className='container'>
                <h2>{t('texto16')} </h2>
                <p>{t('texto17')} <br />  {t('texto18')}</p>
                <div className='services_carga_content'>
                    
                                 
                    <Link to="/maritimo"> 
                    <div className='services_carga_box'>
                        <div className='services_carga_box_img'>
                            <img src={maritimo} alt='servicios terrestres baja ferries' />                        
                            <div className='services_carga_box_text'>
                                <h3>{t('texto13')}</h3>
                                <p>{t('texto19')}</p>
                            </div>
                        </div>                     
                    </div>
                    </Link>
                    <Link to="/integracion-logistica"> 
                    <div className='services_carga_box'>
                        <div className='services_carga_box_img'>
                            <img src={integracion} alt='servicio maritimo baja ferries' />
                            <div className='services_carga_box_text'>
                                <h3>{t('texto12')}</h3>
                                <p>{t('texto22')}</p>
                            </div>
                            
                        </div>
                    </div>
                    </Link>
                    {/*
                    <Link to="/multimodal"> 
                    <div className='services_carga_box'>
                        <div className='services_carga_box_img'>
                            <img src={multimodal} alt='servicios multimodal baja ferries' />                   
                            <div className='services_carga_box_text'>
                                <h3>{t('texto23')}</h3>
                                <p>{t('texto21')}</p>
                            </div>
                        </div>                     
                    </div>
                    </Link>
                    <Link to="/terrestre">             
                    <div className='services_carga_box'>
                        <div className='services_carga_box_img'>
                            <img src={terrestre} alt='' />                      
                            <div className='services_carga_box_text'>
                                <h3>{t('texto14')}</h3>
                                <p>{t('texto20')}</p>
                            </div>
                        </div>                     
                    </div>
                    </Link>
                    <Link to="/integracion-logistica"> 
                    <div className='services_carga_box'>
                        <div className='services_carga_box_img'>
                            <img src={integracion} alt='servicio maritimo baja ferries' />
                            <div className='services_carga_box_text'>
                                <h3>{t('texto12')}</h3>
                                <p>{t('texto22')}</p>
                            </div>
                            
                        </div>
                    </div>
                    </Link>/}
                </div>
            </div>
        </section>
        */}
  
        {/* Rutas, Horarios y Tarifas */}
        <section className='cta_carga'>
        <div className='container'>
            <div className='rutas_horario_text_box'>
                <div className='rutas_horario_text'>
                    <h3>{t('texto24')}</h3>
                    <p>{t('texto25')} <br />
                    {t('texto26')}</p>
                </div>
            </div>
        </div>
        </section>
        <section className='rutas_horario_carga'>
            <div className='container'>
                <div className='cta_container_carga'>
                    <div className='cta_box_carga ruta-horario'>
                        <div className='cta_content_body'>
                            <div className='cta_img_body'><div className='cta_box_img_body'><img src={ruta}  alt='ruta y horarios'/></div></div>
                            <div className='cta_info_body'>                            
                                <div className='cta_text_body carga'>
                                    <h2>{t('ruta_horario_carga_title')}</h2>
                                    <p>{t('ruta_horario_carga_p')}</p>
                                </div>
                                <div className='cta_btn_body'>                                
                                    <Link to="/rutas_horario"> {t('ver_mas')}</Link>
                                </div>
                            </div>
                        </div>                        
                    </div>
                    <div className='cta_box_carga tarifa'>
                        <div className='cta_content_body'>
                            <div className='cta_img_body'><div className='cta_box_img_body'><img src={tarifa} alt='tarifa baja ferries'/></div></div>
                            <div className='cta_info_body'>
                                <div className='cta_text_body carga'>
                                    <h2>{t('tarifa_carga_title')}</h2>
                                    <p>{t('tarifa_carga_p')}</p>
                                </div>                            
                                <div className='cta_btn_body'>
                                    <Link to="/tarifas">{t('ver_mas')} </Link>
                                </div>
                            </div>
                        </div>                   
                    </div>                
                </div>
            </div>
        </section>

        <section className='numeralia_carga'>
            <div className='container'>
                <div className='numeralia_carga_content'>
                    <div className='numeralia_carga_box'>
                        <p>170,000</p>
                        <label>{t('texto27')}</label>
                    </div>
                    <div className='numeralia_carga_box'>
                        <p>210</p>
                        <label> {t('texto28')}</label>
                    </div>
                    <div className='numeralia_carga_box'>
                        <p>26 {t('texto29')} 130</p>
                        <label>{t('texto30')}</label>
                    </div>
                </div>
            </div>
        </section>
        <section className='sostenibilidad-carga'>
            <div className='container'>
                <div className='sostenibilidad-carga-text'>
                    <h2>Sostenibilidad</h2>
                    <p>En Baja Ferries estamos comprometidos voluntaria y públicamente con la responsabilidad social, con una visión clara de ser un referente en integración logística y transporte marítimo, donde la clave de nuestro éxito radique no sólo en lo que hacemos pero más importante aún, en cómo lo hacemos.</p>
                    <Link to="/soluciones-logisticas">Ver más </Link>
                </div>
            </div>
        </section>
        <section className='contacto-carga'>
            <div className='container'>
                <div className='contacto-carga-content'>                         
                    <div className='contacto-carga-content-text'>
                        <h2>{t('texto31')}</h2>
                        <p>{t('texto32')}</p>
                        <ul>
                            <li><label><i class="fi fi-ss-phone-office"></i></label>800 337 7437</li>
                            <li><label><i class="fi fi-sr-envelope"></i></label>contactcenter@bajaferries.com.mx</li>
                            <li><label><i class="fi fi-ss-marker"></i></label>Ignacio Allende No. 1025 Col. Centro, C.P. 23000. La Paz, B.C.S. México</li>
                        </ul>
                    </div>
                    
                    <form class="formulario-contacto-carga">
                        <div>
                            <h2>{t('texto33')}</h2>
                            <p>{t('texto34')}</p>
                        </div>
                        {alert &&
                            <div className='alertMessage'>
                                <label>{t('texto35')}</label>
                                <p>{t('texto36')}</p>

                            </div>
                        }

                            <div class="form-group">
                                <input
                                    type="text"
                                    placeholder="Nombre"
                                    value={nombre}
                                    onChange={(e) => setNombre(e.target.value)}
                                />
                                <input
                                    type="text"
                                    placeholder="Empresa (opcional)"
                                    value={empresa}
                                    onChange={(e) => setEmpresa(e.target.value)}
                                />
                                
                            </div>
                            <div class="form-group">
                                <input type='text'
                                    value={telefono}
                                    onChange={(e) => setTelefono(e.target.value)} 
                                    placeholder="Teléfono" />

                                <input type="email"
                                    placeholder="Correo"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    />
                            </div>
                            
                            <div>
                                <textarea 
                                    placeholder="Escribe tu mensaje..."
                                    value={mensaje}
                                    onChange={(e) => setMensaje(e.target.value)}
                                    >
                                </textarea>
                            </div>
                            
                            <div class="btn-formulario-carga">
                                
                                <button
                                    class="btn_enviar"                                 
                                    onClick={enviarCorreo}
                                    >
                                    Enviar <i class="fi fi-rs-paper-plane-top"></i>
                                </button>

                            </div>
                                
                    </form>                
                </div>               
            </div>
        </section>
    </section>
    <section className="callToAction carga">
        <div className='container'>
            
            <div className='callToAction_row'>
                <div className='callToAction_container carga'>
                    <div className='callToAction_icon'>
                        <img src={formulario} alt="bookingIcon" className='bookingIcon' />
                    </div>
                    <div className='callToAction_content'>
                        <div className='callToAction_box'>
                            <div>
                                <h4>{t('cta1_title1')}</h4>
                            </div>
                            <div>
                                <p>{t('cta_title1')} </p>
                            </div>
                        </div>
                        <div className='callToAction_box'>
                            <Link to="/rutas-horario-carga">{t('cta_btn1')}</Link>     
                        </div>
                    </div>
                </div>
                <div className='callToAction_container carga'>
                    <div className='callToAction_icon'>
                        <img src={mapa} alt="bookingIcon" className='bookingIcon' />
                    </div>
                    <div className='callToAction_content'>
                        <div className='callToAction_box'>
                            <div>
                                <h4>{t('cta1_title2')}</h4>
                            </div>
                            <div>
                                <p>{t('cta_title2')} </p>
                            </div>
                        </div>
                        <div className='callToAction_box'>
                            <Link to="/preguntas-frecuentes">{t('cta_btn2')}</Link>     
                        </div>
                    </div>
                </div>
                {/*<div className='callToAction_container carga'>
                    <div className='callToAction_icon'>
                        <img src={whatsapp} alt="bookingIcon" className='bookingIcon' />
                    </div>
                    <div className='callToAction_content'>
                        <div className='callToAction_box'>
                            <div>
                                <h4>Envianos un WhatsApp</h4>
                            </div>
                            <div>
                                <p>Comunícate con nosotros al instante. Ya sea que tengas preguntas sobre nuestro servicio, o sobre tu reservación nuestro equipo está listo para ayudarte.</p>
                            </div>
                        </div>
                        <div className='callToAction_box'>
                        <a href="https://wa.me/5218003377437?text=Me%20interesa%20una%20cotizaci%C3%B3n" target="_blank" rel="noopener noreferrer">Enviar WhatsApp </a>                    
                        </div>
                    </div>
                </div>*/}
                 <div className='callToAction_container carga'>
                    <div className='callToAction_icon'>
                        <img src={reservacion} alt="bookingIcon" className='bookingIcon' />
                    </div>
                    <div className='callToAction_content'>
                        <div className='callToAction_box'>
                            <div>
                                <h4>{t('cta1_title3')}</h4>
                            </div>
                            <div>
                                <p>{t('cta_title3')} </p>
                            </div>
                        </div>
                        <div className='callToAction_box'>                            
                            <a href="tel:8003377437" rel="noopener noreferrer"><span >{t('cta_btn3')}</span></a>    
                        </div>
                    </div>
                </div>
            </div>

        </div>
   </section>

    <FooterCarga />
    <Outlet />
    
    </>
  )
}
